import styled from 'styled-components';

export const Label = styled.span`
  color: #fafafa;
`;
